import React from 'react';
import styled from "styled-components";

const SGrammarIntroducion = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const GrammarIntroducion = () => {
  return (
  <SGrammarIntroducion>
<h5>Wprowadzenie do gramatyki języka hiszpańskiego</h5>

<p>
Hiszpański to język wywodzący się z łaciny, dlatego też jest w wielu swoich aspektach podobny do języka polskiego. Najważniejszym podobieństwem jest odmiana czasowników przez osoby (koniugacja), z czym wiąże się częste opuszczanie zaimków osobowych. Używa się ich tylko przy podkreślaniu, o kim mówimy, lub przy kontrastowaniu dwóch osób. Nie istnieje natomiast w hiszpańskim deklinacja (odmiana przez przypadki), w dużej mierze zastąpiona użyciem przyimków. Poza tym różni te dwa języki zjawisko występujące też w innych językach popularnych w Polsce: rodzajniki.
</p>
<p>
Hiszpańskie rzeczowniki i przymiotniki mają jeden z dwóch rodzajów, męski lub żeński. Na rodzaj najczęściej wskazują nam końcówki słów, np. większość słów rodzaju męskiego kończy się na <i>-o</i> lub na spółgłoskę, a większość żeńskich - na <i>-a</i>. Słowa zakończone na <i>-e</i> są przeważnie wspólne dla obu rodzajów. Poza tym mamy tu liczbę pojedynczą i mnogą, którą tworzy się dodając do słów zakończonych na samogłoskę końcówkę <i>-s</i>, a do tych zakończonych na spółgłoskę <i>-es</i>.
</p>
<p>
Hiszpańska składnia, czyli kolejność wyrazów w zdaniu, jest dosyć dowolna; oczywiście najlepiej zaczynać się uczyć tego języka, ustawiając słowa w następującym porządku: podmiot, orzeczenie i reszta. Ale w miarę upływu czasu i nabierania wprawy, na początku zdania stawiajmy słowa najważniejsze dla naszej wypowiedzi.
</p>
<p>
W hiszpańskim zaprzeczenia oraz pytania tworzy się banalnie: żeby zaprzeczyć, trzeba postawić słowo <i>no</i> (nie) przed czasownikiem, a pytania najlepiej konstruować zmieniając intonację.
</p>
<p>
Akcenty rozkładają się w hiszpańskim trochę inaczej niż w polskim: słowa zakończone na samogłoskę lub <i>-s</i> czy <i>-n</i> są akcentowane na przedostatnią sylabę, a te zakończone na spółgłoskę akcentują się na ostatnią sylabę. Wszystkie słowa poza tymi regułami mają akcent graficzny.
</p>
  </SGrammarIntroducion>
  );
};

export default GrammarIntroducion;